import { type SerializeFrom } from '@remix-run/server-runtime';
import { type DehydratedState } from '@tanstack/react-query';

export function invalidDehydratedState(
	dehydratedState:
		| DehydratedState
		| null
		| undefined
		| SerializeFrom<DehydratedState | null>,
): dehydratedState is DehydratedState {
	return (
		(dehydratedState &&
			(dehydratedState.queries.length === 0 ||
				dehydratedState.queries.every(query => query.state.data === null))) ||
		false
	);
}
